/* eslint-disable @typescript-eslint/no-explicit-any */
import { v4 as uuid } from 'uuid';

const statesListFull = [
  {
    label: 'Alabama',
    value: 'AL',
  },
  {
    label: 'Alaska',
    value: 'AK',
  },
  {
    label: 'American Samoa',
    value: 'AS',
  },
  {
    label: 'Arizona',
    value: 'AZ',
  },
  {
    label: 'Arkansas',
    value: 'AR',
  },
  {
    label: 'California',
    value: 'CA',
  },
  {
    label: 'Colorado',
    value: 'CO',
  },
  {
    label: 'Connecticut',
    value: 'CT',
  },
  {
    label: 'Delaware',
    value: 'DE',
  },
  {
    label: 'District Of Columbia',
    value: 'DC',
  },
  {
    label: 'Federated States Of Micronesia',
    value: 'FM',
  },
  {
    label: 'Florida',
    value: 'FL',
  },
  {
    label: 'Georgia',
    value: 'GA',
  },
  {
    label: 'Guam',
    value: 'GU',
  },
  {
    label: 'Hawaii',
    value: 'HI',
  },
  {
    label: 'Idaho',
    value: 'ID',
  },
  {
    label: 'Illinois',
    value: 'IL',
  },
  {
    label: 'Indiana',
    value: 'IN',
  },
  {
    label: 'Iowa',
    value: 'IA',
  },
  {
    label: 'Kansas',
    value: 'KS',
  },
  {
    label: 'Kentucky',
    value: 'KY',
  },
  {
    label: 'Louisiana',
    value: 'LA',
  },
  {
    label: 'Maine',
    value: 'ME',
  },
  {
    label: 'Marshall Islands',
    value: 'MH',
  },
  {
    label: 'Maryland',
    value: 'MD',
  },
  {
    label: 'Massachusetts',
    value: 'MA',
  },
  {
    label: 'Michigan',
    value: 'MI',
  },
  {
    label: 'Minnesota',
    value: 'MN',
  },
  {
    label: 'Mississippi',
    value: 'MS',
  },
  {
    label: 'Missouri',
    value: 'MO',
  },
  {
    label: 'Montana',
    value: 'MT',
  },
  {
    label: 'Nebraska',
    value: 'NE',
  },
  {
    label: 'Nevada',
    value: 'NV',
  },
  {
    label: 'New Hampshire',
    value: 'NH',
  },
  {
    label: 'New Jersey',
    value: 'NJ',
  },
  {
    label: 'New Mexico',
    value: 'NM',
  },
  {
    label: 'New York',
    value: 'NY',
  },
  {
    label: 'North Carolina',
    value: 'NC',
  },
  {
    label: 'North Dakota',
    value: 'ND',
  },
  {
    label: 'Northern Mariana Islands',
    value: 'MP',
  },
  {
    label: 'Ohio',
    value: 'OH',
  },
  {
    label: 'Oklahoma',
    value: 'OK',
  },
  {
    label: 'Oregon',
    value: 'OR',
  },
  {
    label: 'Palau',
    value: 'PW',
  },
  {
    label: 'Pennsylvania',
    value: 'PA',
  },
  {
    label: 'Puerto Rico',
    value: 'PR',
  },
  {
    label: 'Rhode Island',
    value: 'RI',
  },
  {
    label: 'South Carolina',
    value: 'SC',
  },
  {
    label: 'South Dakota',
    value: 'SD',
  },
  {
    label: 'Tennessee',
    value: 'TN',
  },
  {
    label: 'Texas',
    value: 'TX',
  },
  {
    label: 'Utah',
    value: 'UT',
  },
  {
    label: 'Vermont',
    value: 'VT',
  },
  {
    label: 'Virgin Islands',
    value: 'VI',
  },
  {
    label: 'Virginia',
    value: 'VA',
  },
  {
    label: 'Washington',
    value: 'WA',
  },
  {
    label: 'West Virginia',
    value: 'WV',
  },
  {
    label: 'Wisconsin',
    value: 'WI',
  },
  {
    label: 'Wyoming',
    value: 'WY',
  },
];

const statesList = [
  { label: 'AL', value: 'AL' },
  { label: 'AK', value: 'AK' },
  { label: 'AZ', value: 'AZ' },
  { label: 'AR', value: 'AR' },
  { label: 'CA', value: 'CA' },
  { label: 'CO', value: 'CO' },
  { label: 'CT', value: 'CT' },
  { label: 'DE', value: 'DE' },
  { label: 'DC', value: 'DC' },
  { label: 'FL', value: 'FL' },
  { label: 'GA', value: 'GA' },
  { label: 'HI', value: 'HI' },
  { label: 'ID', value: 'ID' },
  { label: 'IL', value: 'IL' },
  { label: 'IN', value: 'IN' },
  { label: 'IA', value: 'IA' },
  { label: 'KS', value: 'KS' },
  { label: 'KY', value: 'KY' },
  { label: 'LA', value: 'LA' },
  { label: 'ME', value: 'ME' },
  { label: 'MD', value: 'MD' },
  { label: 'MA', value: 'MA' },
  { label: 'MI', value: 'MI' },
  { label: 'MN', value: 'MN' },
  { label: 'MS', value: 'MS' },
  { label: 'MO', value: 'MO' },
  { label: 'MT', value: 'MT' },
  { label: 'NE', value: 'NE' },
  { label: 'NV', value: 'NV' },
  { label: 'NH', value: 'NH' },
  { label: 'NJ', value: 'NJ' },
  { label: 'NM', value: 'NM' },
  { label: 'NY', value: 'NY' },
  { label: 'NC', value: 'NC' },
  { label: 'ND', value: 'ND' },
  { label: 'OH', value: 'OH' },
  { label: 'OK', value: 'OK' },
  { label: 'OR', value: 'OR' },
  { label: 'PA', value: 'PA' },
  { label: 'RI', value: 'RI' },
  { label: 'SC', value: 'SC' },
  { label: 'SD', value: 'SD' },
  { label: 'TN', value: 'TN' },
  { label: 'TX', value: 'TX' },
  { label: 'UT', value: 'UT' },
  { label: 'VT', value: 'VT' },
  { label: 'VA', value: 'VA' },
  { label: 'WA', value: 'WA' },
  { label: 'WV', value: 'WV' },
  { label: 'WI', value: 'WI' },
  { label: 'WY', value: 'WY' },
];

const firstName = (
  isCustomerForm = false,
  type = 'input',
  required = true,
  className?: string
) => {
  return {
    key: uuid(),
    type,
    templateOptions: {
      label: 'First Name',
      required,
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      placeholder: 'First Name',
    },
  };
};

const lastName = (
  isCustomerForm = false,
  type = 'input',
  required = true,
  className?: string
) => {
  return {
    key: uuid(),
    type,
    templateOptions: {
      label: 'Last Name',
      required,
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      placeholder: 'Last Name',
    },
  };
};

const companyName = (
  isCustomerForm = false,
  required = true,
  className?: string
) => {
  return {
    key: uuid(),
    label: 'Company Name',
    value: 'companyName',
    src: 'assets/icons/input.svg',
    type: 'companyName',
    templateOptions: {
      label: 'Company Name',
      required,
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      placeholder: 'Company Name',
    },
  };
};

const birthday = (isCustomerForm = false) => {
  return {
    type: 'input',
    key: uuid(),
    templateOptions: {
      type: 'date',
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'Birthday',
      placeholder: 'Birthday',
    },
  };
};

const gender = (isCustomerForm = false) => {
  return {
    type: 'radio',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'customer-radio' : 'intake-radio',
      label: 'Gender',
      placeholder: 'Radio',
      options: [
        {
          label: 'Male',
          value: 'Male',
        },
        {
          label: 'Female',
          value: 'Female',
        },
      ],
    },
  };
};

const maritalStatus = (isCustomerForm = false) => {
  return {
    type: 'select',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'Marital Status',
      placeholder: 'Marital Status',
      options: [
        {
          label: 'Married',
          value: 'Married',
        },
        {
          label: 'Single',
          value: 'Single',
        },
        {
          label: 'Separated',
          value: 'Separated',
        },
        {
          label: 'Divorced',
          value: 'Divorced',
        },
        {
          label: 'Widowed',
          value: 'Widowed',
        },
        {
          label: 'Domestic Partner',
          value: 'Domestic Partner',
        },
      ],
    },
  };
};

const relationship = (isCustomerForm = false) => {
  return {
    type: 'select',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'Relationship',
      placeholder: 'Relationship',
      options: [
        {
          label: 'Insured',
          value: 'Insured',
        },
        {
          label: 'Child',
          value: 'Child',
        },
        {
          label: 'Employee',
          value: 'Employee',
        },
        {
          label: 'Other',
          value: 'Other',
        },
        {
          label: 'Parent',
          value: 'Parent',
        },
        {
          label: 'Relative',
          value: 'Relative',
        },
        {
          label: 'Spouse',
          value: 'Spouse',
        },
      ],
    },
  };
};

const industry = (isCustomerForm = false, className?: string) => {
  return {
    type: 'select',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'Industry',
      placeholder: 'Industry',
      dataKey: 'industry',
    },
  };
};

const occupation = (isCustomerForm = false, className?: string) => {
  return {
    type: 'select',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'Occupation',
      placeholder: 'Occupation',
      dataKey: 'occupation',
    },
  };
};

const educationLevel = (isCustomerForm = false) => {
  return {
    type: 'select',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'Education Level',
      placeholder: 'Education Level',
      options: [
        {
          label: 'No High School Diploma',
          value: 'No High School Diploma',
        },
        {
          label: 'Some College - No Degree',
          value: 'Some College - No Degree',
        },
        {
          label: 'Vocational/Technical Degree',
          value: 'Vocational/Technical Degree',
        },
        {
          label: 'Associates Degree',
          value: 'Associates Degree',
        },
        {
          label: 'Bachelors',
          value: 'Bachelors',
        },
        {
          label: 'Masters',
          value: 'Masters',
        },
        {
          label: 'Phd',
          value: 'Phd',
        },
        {
          label: 'Medical Degree',
          value: 'Medical Degree',
        },
        {
          label: 'Law Degree',
          value: 'Law Degree',
        },
      ],
    },
  };
};

const driversLicenseNumber = (
  isCustomerForm = false,
  required = true
  ) => {
  return {
    type: 'input',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: "Driver's License Number",
      placeholder: "Driver's License Number",
      required,
    },
  };
};

const licenseState = (isCustomerForm = false) => {
  return {
    type: 'select',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'License State',
      placeholder: 'License State',
      options: statesList,
    },
  };
};

const ageLicensed = (isCustomerForm = false) => {
  return {
    type: 'input',
    key: uuid(),
    templateOptions: {
      type: 'number',
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'Age Licensed',
      placeholder: 'Age Licensed',
      min: '14',
    },
  };
};

const vin = (isCustomerForm = false) => {
  return {
    key: uuid(),
    type: 'input',
    templateOptions: {
      label: 'VIN',
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      placeholder: 'VIN',
      dataKey: 'vin',
      maxLength: '17',
      minLength: '17',
    },
  };
};

const vehicleYear = (isCustomerForm = false, className?: string, subType = 'passenger') => {
  return {
    key: uuid(),
    type: 'select',
    templateOptions: {
      label: 'Year',
      options: [],
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      placeholder: 'Year',
      dataKey: 'vehicleYear',
      subType: subType
    },
  };
};

const vehicleMake = (isCustomerForm = false, className?: string, subType = 'passenger') => {
  return {
    key: uuid(),
    type: 'select',
    templateOptions: {
      label: 'Make',
      options: [],
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      placeholder: 'Make',
      dataKey: 'vehicleMake',
      subType: subType
    },
  };
};

const vehicleModel = (isCustomerForm = false, className?: string, subType = 'passenger') => {
  return {
    key: uuid(),
    type: 'select',
    templateOptions: {
      label: 'Model',
      options: [],
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      placeholder: 'Model',
      dataKey: 'vehicleModel',
      subType: subType
    },
  };
};

const bodyStyle = (isCustomerForm = false, className?: string, subType = 'passenger') => {
  return {
    key: uuid(),
    type: 'select',
    templateOptions: {
      label: 'Body Style',
      options: [],
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      placeholder: 'Body Style',
      dataKey: 'vehicleBodyStyle',
      subType: subType
    },
  };
};

const primaryUse = (isCustomerForm = false) => {
  return {
    key: uuid(),
    type: 'radio',
    templateOptions: {
      label: 'Primary Use',
      options: [
        {
          label: 'Business',
          value: 'Business',
        },
        {
          label: 'Pleasure',
          value: 'Pleasure',
        },
        {
          label: 'To/From Work',
          value: 'To/From Work',
        },
        {
          label: 'To/From School',
          value: 'To/From School',
        },
      ],
      className: isCustomerForm ? 'customer-radio' : 'intake-radio',
      placeholder: 'Radio',
    },
  };
};

const ownershipType = (isCustomerForm = false) => {
  return {
    key: uuid(),
    type: 'radio',
    templateOptions: {
      label: 'Ownership Type',
      options: [
        {
          label: 'Owned',
          value: 'Owned',
        },
        {
          label: 'Leased',
          value: 'Leased',
        },
        {
          label: 'Financed',
          value: 'Financed',
        },
      ],
      className: isCustomerForm ? 'customer-radio' : 'intake-radio',
      placeholder: 'Radio',
    },
  };
};

const purchaseDate = (isCustomerForm = false) => {
  return {
    key: uuid(),
    type: 'input',
    templateOptions: {
      type: 'date',
      label: 'Purchase Date',
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      placeholder: 'Purchase Date',
    },
  };
};

const annualMiles = (isCustomerForm = false) => {
  return {
    key: uuid(),
    type: 'input',
    templateOptions: {
      type: 'number',
      label: 'Annual Miles',
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      placeholder: 'Annual Miles',
    },
  };
};

const selectMenu = (isCustomerForm = false, className?: string) => {
  return {
    id: 0,
    label: 'Select Menu',
    value: 'selectMenu',
    src: 'assets/icons/select-menu.svg',
    type: 'select',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'Select menu',
      placeholder: 'Select menu',
      options: [{ label: 'Option 1', value: 'Option 1' }],
    },
  };
};

const selectBox = (
  isCustomerForm = false,
  options: { label: string; value: any }[] = [] //tslint:disable-line
) => {
  return {
    id: '0',
    label: 'Select Box',
    value: 'selectBox',
    src: 'assets/icons/select-menu.svg',
    type: 'selectbox',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'Select box',
      placeholder: 'Select Box',
      options:
        options.length > 0
          ? options
          : [{ label: 'Option 1', value: 'Option 1' }],
    },
  };
};

const text = (isCustomerForm = false, className?: string) => {
  const obj = {
    id: 1,
    label: 'Text',
    value: 'text',
    src: 'assets/icons/input.svg',
    type: 'input',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'Text',
      placeholder: 'Text',
    },
  };

  if (className == 'table-input') {
    obj.templateOptions['columnName'] = 'Text';
    obj.templateOptions.className = className;
  }

  return obj;
};

const number = (isCustomerForm = false, className?: string) => {
  const obj = {
    id: 2,
    label: 'Number',
    value: 'number',
    src: 'assets/icons/number.svg',
    type: 'input',
    key: uuid(),
    templateOptions: {
      type: 'number',
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'Number',
      placeholder: 'Number',
      columnName: 'Number',
    },
  };
  if (className == 'table-input') {
    obj.templateOptions.className = className;
  }
  return obj;
};

const currency = (isCustomerForm = false, className?: string) => {
  const obj = {
    id: 2,
    label: 'Currency',
    value: 'currency',
    src: 'assets/icons/number.svg',
    type: 'currency',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'Currency',
      placeholder: 'Currency',
      columnName: 'Currency',
    },
  };
  if (className == 'table-input') {
    obj.templateOptions.className = className;
  }
  return obj;
};

const radio = (isCustomerForm = false) => {
  return {
    id: 3,
    label: 'Radio',
    value: 'selectOne',
    src: 'assets/icons/radio.svg',
    type: 'radio',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'customer-radio' : 'intake-radio',
      label: 'Radio',
      placeholder: 'Radio',
      options: [{ label: 'Option 1', value: 'Option 1' }],
    },
  };
};

const checkbox = (isCustomerForm = false, className?: string) => {
  return {
    id: 4,
    label: 'Checkbox',
    value: 'checkbox',
    src: 'assets/icons/checkbox.svg',
    type: 'checkbox',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'Checkbox',
      placeholder: 'Checkbox',
      text: 'Do you agree?',
    },
  };
};

const address = (isCustomerForm = false, className?: string) => {
  const addressFieldkey = uuid();
  return {
    id: 5,
    label: 'Address',
    value: 'address',
    src: 'assets/icons/location.svg',
    isGroup: true,
    data: [
      {
        type: 'address',
        key: addressFieldkey,
        templateOptions: {
          dataKey: addressFieldkey,
          className: isCustomerForm
            ? 'xilo-input'
            : className
            ? className
            : 'intake-input',
          label: 'Address',
          placeholder: 'Address',
        },
      },
      {
        type: 'input',
        key: uuid(),
        hide: true,
        templateOptions: {
          dataKey: addressFieldkey + 'streetAddress',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'Street Address',
          placeholder: 'Street Address',
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey,
        },
      },
      {
        type: 'input',
        key: uuid(),
        hide: true,
        templateOptions: {
          dataKey: addressFieldkey + 'streetName',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'Street Name',
          placeholder: 'Street Name',
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey,
        },
      },
      {
        type: 'input',
        key: uuid(),
        hide: true,
        templateOptions: {
          dataKey: addressFieldkey + 'streetNumber',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'Street Number',
          placeholder: 'Street Number',
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey,
        },
      },
      {
        type: 'input',
        key: uuid(),
        hide: true,
        templateOptions: {
          dataKey: addressFieldkey + 'city',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'City',
          placeholder: 'City',
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey,
        },
      },
      {
        type: 'input',
        key: uuid(),
        hide: true,
        templateOptions: {
          dataKey: addressFieldkey + 'county',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'County',
          placeholder: 'County',
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey,
        },
      },
      {
        type: 'select',
        key: uuid(),
        hide: true,
        templateOptions: {
          dataKey: addressFieldkey + 'state',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'State',
          placeholder: 'State',
          options: statesList,
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey,
        },
      },
      {
        type: 'input',
        key: uuid(),
        hide: true,
        templateOptions: {
          dataKey: addressFieldkey + 'zipCode',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'Zip Code',
          placeholder: 'Zip Code',
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey,
        },
      },
    ],
  };
};

const addressV2 = (isCustomerForm = false, className?: string) => {
  const addressFieldkey2 = uuid();
  return {
    id: 16,
    label: 'Address (new)',
    value: 'address',
    src: 'assets/icons/location.svg',
    isGroup: true,
    tooltip: 'Allows user to include unit number.',
    data: [
      {
        type: 'addressV2',
        key: addressFieldkey2,
        className: isCustomerForm ? 'col-12' : '',
        templateOptions: {
          version: 2,
          dataKey: addressFieldkey2,
          className: isCustomerForm
            ? 'xilo-input'
            : className
            ? className
            : 'intake-input',
          label: 'Address',
          placeholder: 'Address',
        },
      },
      {
        type: 'input',
        key: uuid(),
        hide: false,
        className: isCustomerForm ? 'col-12' : '',
        templateOptions: {
          version: 2,
          dataKey: addressFieldkey2 + 'streetAddress2',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'Street Address 2 (Optional)',
          placeholder: 'Apartment, Suite, Unit, etc. (optional)',
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey2,
        },
      },
      {
        type: 'input',
        key: uuid(),
        hide: false,
        className: isCustomerForm ? 'col-12' : '',
        templateOptions: {
          version: 2,
          dataKey: addressFieldkey2 + 'city',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'City',
          placeholder: 'City',
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey2,
        },
      },
      {
        type: 'select',
        key: uuid(),
        hide: false,
        className: isCustomerForm ? 'col-6 col-md-12' : '',
        templateOptions: {
          version: 2,
          dataKey: addressFieldkey2 + 'state',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'State',
          placeholder: 'State',
          options: statesListFull,
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey2,
        },
      },
      {
        type: 'input',
        key: uuid(),
        hide: false,
        className: isCustomerForm ? 'col-6 col-md-12' : '',
        templateOptions: {
          version: 2,
          dataKey: addressFieldkey2 + 'zipCode',
          className: isCustomerForm ? 'xilo-input' : 'intake-input',
          label: 'Zip Code',
          placeholder: 'Zip Code',
          preventDrag: true,
          preventAddQuestion: true,
          lockedTo: addressFieldkey2,
        },
      },
      {
        key: uuid(),
        hide: false,
        className: isCustomerForm ? '' : 'invisible',
        templateOptions: {},
      },
    ],
  };
};

const date = (isCustomerForm = false, className?: string) => {
  return {
    id: 6,
    label: 'Date',
    value: 'date',
    src: 'assets/icons/date.svg',
    type: 'input',
    key: uuid(),
    templateOptions: {
      type: 'date',
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'Date',
      placeholder: 'Date',
    },
  };
};

const phone = (isCustomerForm = false, className?: string) => {
  return {
    id: 7,
    label: 'Phone',
    value: 'phonenumber',
    src: 'assets/icons/phonenumber.svg',
    type: 'phonenumber',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'Phone',
      placeholder: 'Phone',
    },
  };
};

const email = (isCustomerForm = false, className?: string) => {
  return {
    id: 8,
    label: 'Email',
    value: 'email',
    src: 'assets/icons/email.svg',
    type: 'input',
    key: uuid(),
    templateOptions: {
      type: 'email',
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'Email',
      placeholder: 'Email',
    },
  };
};

const password = (isCustomerForm = false, className?: string) => {
  return {
    id: 9,
    label: 'Password',
    value: 'password',
    src: 'assets/icons/password.svg',
    type: 'input',
    key: uuid(),
    templateOptions: {
      type: 'password',
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'Password',
      placeholder: 'Password',
    },
  };
};

const paragraph = (isCustomerForm = false) => {
  return {
    id: 10,
    label: 'Paragraph',
    value: 'textarea',
    src: 'assets/icons/paragraph.svg',
    type: 'textarea',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      label: 'Paragraph',
      placeholder: 'Paragraph',
    },
  };
};

const name = (isCustomerForm = false, className?: string) => {
  return {
    id: 11,
    label: 'Name',
    value: 'name',
    src: 'assets/icons/input.svg',
    isGroup: true,
    data: [
      firstName(isCustomerForm, 'firstName', false, className),
      lastName(isCustomerForm, 'lastName', false, className),
    ],
  };
};

const industryAndOccupation = (isCustomerForm = false, className?: string) => {
  return {
    id: 12,
    label: 'Industry & Occupation',
    value: 'industryOccupation',
    src: 'assets/icons/select-menu.svg',
    isGroup: true,
    data: [
      industry(isCustomerForm, className),
      occupation(isCustomerForm, className),
    ],
  };
};

const vehicleSelect = (isCustomerForm = false, className?: string) => {
  return {
    id: 13,
    label: 'Vehicle Select',
    value: 'vehicleSelect',
    src: 'assets/icons/select-menu.svg',
    isGroup: true,
    data: [
      vehicleYear(isCustomerForm, className),
      vehicleMake(isCustomerForm, className),
      vehicleModel(isCustomerForm, className),
      bodyStyle(isCustomerForm, className),
    ],
  };
};

const vinDecoder = (isCustomerForm = false, className?: string) => {
  return {
    id: 14,
    label: 'VIN Decoder',
    value: 'vinDecoder',
    src: 'assets/icons/input.svg',
    type: 'input',
    key: uuid(),
    templateOptions: {
      dataKey: 'vin',
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'VIN',
      placeholder: 'VIN',
      maxLength: '17',
      minLength: '17',
    },
  };
};

const plainText = (isCustomerForm = false, className?: string) => {
  const obj = {
    id: 15,
    label: 'Plain Text',
    value: 'text',
    src: 'assets/icons/input.svg',
    type: 'text',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'Plain text',
    },
  };

  if (className === 'table-input') {
    obj.templateOptions['columnName'] = 'Plain Text';
  }

  return obj;
};

const calculator = (isCustomerForm = false, className?: string) => {
  const obj = {
    id: 16,
    label: 'Calculator',
    value: 'calculator',
    src: 'assets/icons/number.svg',
    type: 'calculator',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'Calculation',
      fontSize: '1rem',
      color: 'black',
      fontWeight: '600',
      borderBottom: null,
      textAlign: 'left',
      singleColumn: false,
    },
  };

  return obj;
};

const rvSelect = (isCustomerForm = false, className?: string) => {
  return {
    id: 17,
    label: 'RV Select',
    value: 'rvSelect',
    src: 'assets/icons/select-menu.svg',
    isGroup: true,
    data: [
      vehicleYear(isCustomerForm, className, 'rv'),
      vehicleMake(isCustomerForm, className, 'rv'),
      vehicleModel(isCustomerForm, className, 'rv'),
      bodyStyle(isCustomerForm, className, 'rv'),
    ],
  };
};

const hasIncident = (isCustomerForm = false) => {
  return {
    key: uuid(),
    type: 'checkbox',
    templateOptions: {
      text: 'Has Accident, Violation or Claim',
      label: 'Checkbox',
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      placeholder: 'Checkbox',
    },
  };
};
const incidentDescription = (isCustomerForm = false) => {
  return {
    key: uuid(),
    type: 'input',
    templateOptions: {
      label: 'Incident Description',
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      placeholder: 'Incident Description',
    },
  };
};
const incidentDate = (isCustomerForm = false) => {
  return {
    key: uuid(),
    type: 'input',
    templateOptions: {
      type: 'date',
      label: 'Incident Date',
      className: isCustomerForm ? 'xilo-input' : 'intake-input',
      placeholder: 'Incident Date',
    },
  };
};

const fileUpload = (isCustomerForm = false, className?: string) => {
  return {
    id: 1,
    label: 'File Upload',
    value: 'fileUpload',
    src: 'assets/icons/input.svg',
    type: 'file-upload',
    key: uuid(),
    templateOptions: {
      className: isCustomerForm
        ? 'xilo-input'
        : className
        ? className
        : 'intake-input',
      label: 'File Upload',
      placeholder: 'Upload File',
    },
  };
};

export const questionComponents = {
  firstName,
  lastName,
  companyName,
  birthday,
  gender,
  maritalStatus,
  relationship,
  industry,
  occupation,
  educationLevel,
  driversLicenseNumber,
  licenseState,
  ageLicensed,
  vin,
  vehicleYear,
  vehicleMake,
  vehicleModel,
  bodyStyle,
  primaryUse,
  ownershipType,
  purchaseDate,
  annualMiles,
  selectMenu,
  text,
  number,
  currency,
  radio,
  checkbox,
  address,
  addressV2,
  date,
  phone,
  email,
  password,
  paragraph,
  name,
  industryAndOccupation,
  vehicleSelect,
  rvSelect,
  vinDecoder,
  plainText,
  calculator,
  hasIncident,
  incidentDate,
  incidentDescription,
  selectBox,
  fileUpload,
};
